/* eslint-disable react-refresh/only-export-components */
import '../../styles.css';

import React, { useEffect, useState } from 'react';
import { Outlet, useOutletContext } from "react-router";
import { IContainer } from '../../common/ContainerSchemas';
import { isInShell } from '../../common/Shell';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import { HomeLoginComponent } from '../../components/HomeLoginComponent';
import KaiaBanner from '../../components/kaia-shell-banner/KaiaShellBanner';
import KaiaContactFormDialog from '../../dialogs/KaiaContactFormDialog';
import { useClarity } from '../../utils/useClarity';
import { Constants } from '../../common/Constants';

const InShellTitle = ({ inShell }: { inShell?: boolean }) => {
  if (!inShell) return <></>;
  return <h1 className='in-shell-title'>Documents</h1>;
}

type ContextType = {
  selectedContainer: IContainer | null,
  setSelectedContainer: React.Dispatch<React.SetStateAction<IContainer | null>>,
  openKaiaContactForm: () => void
};

export function useContainer() {
  return useOutletContext<ContextType>();
}

export default function Home() {
  const [selectedContainer, setSelectedContainer] = useState<IContainer | null>(null);
  const [isKaiaContactFormOpen, setIsKaiaContactFormOpen] = useState<boolean>(false);
  const mainContentRef = React.useRef(null);
  const { trackEvent } = useClarity();
  const inShell = React.useMemo(() => isInShell(), [])

  const openKaiaContactForm = () => {
    setIsKaiaContactFormOpen(true);
  }

  const closeKaiaContactForm = () => {
    setIsKaiaContactFormOpen(false);
  }

  useEffect(() => {
    // Track home page visit
    trackEvent('home_page_visited');
  }, [trackEvent]);

  return (
    <div className='kt-ui-app fullScreen'>
      <Header />
      <div className={`App ${inShell ? 'in-shell' : ''}`}>
        <div className="spe-app-content">
          <div className="spe-app-content-main" ref={mainContentRef}>
            <div className="main-content-body">
              <InShellTitle inShell={inShell} />
              <KaiaBanner openKaiaContactForm={openKaiaContactForm} shouldRender={inShell && Constants.isFeatureEnabled('KAIA_ENABLED')} />
              <Outlet context={{ selectedContainer, setSelectedContainer, openKaiaContactForm }} />
              <HomeLoginComponent isLoggedIn={true} />
              <KaiaContactFormDialog isOpen={isKaiaContactFormOpen && inShell && Constants.isFeatureEnabled('KAIA_ENABLED')} onClose={closeKaiaContactForm} />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
